module.exports = __webpack_public_path__ + "static/media/30OIOS12.69671f71.jpg";